module.exports = new __parcel__URL__("stakeholders.9ba74311.svg").toString();